/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateQuoteCustomDto } from '../models/CreateQuoteCustomDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QuoteCustomizableApi {

    /**
     * @returns any 
     * @throws ApiError
     */
    public static postQuoteCustomizablePdf({
requestBody,
}: {
requestBody: CreateQuoteCustomDto,
}): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quoteCustomizable/customizable/quote',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
